/**
 * Stagger Reveal Animation
 * Animación en cascada para elementos al hacer scroll
 *
 * Uso: Agregar clase "stagger-reveal" a los elementos que deben animarse
 * El script agregará la clase "is-visible" cuando entren al viewport
 */

(function() {
  'use strict';

  // Configuración del IntersectionObserver
  const observerOptions = {
    root: null, // Viewport como root
    rootMargin: '-50px', // Anima un poco antes de ser completamente visible
    threshold: 0.15 // 15% del elemento visible para activar
  };

  /**
   * Callback cuando un elemento entra/sale del viewport
   * @param {IntersectionObserverEntry[]} entries
   * @param {IntersectionObserver} observer
   */
  function handleIntersection(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // Agregar clase para activar la animación
        entry.target.classList.add('is-visible');

        // Des-observar el elemento (solo anima una vez)
        observer.unobserve(entry.target);
      }
    });
  }

  /**
   * Verifica si el usuario prefiere movimiento reducido
   * @returns {boolean}
   */
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Inicializa el observer para los elementos con stagger-reveal
   */
  function initStaggerReveal() {
    var elements = document.querySelectorAll('.stagger-reveal');

    // Si el usuario prefiere reduced-motion, mostrar inmediatamente sin delays
    if (prefersReducedMotion()) {
      elements.forEach(function(el) {
        el.classList.add('is-visible');
        el.style.transitionDelay = '0ms';
      });
      return;
    }

    // Verificar soporte de IntersectionObserver
    if (!('IntersectionObserver' in window)) {
      // Fallback: mostrar todos los elementos inmediatamente
      elements.forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }

    // Crear el observer
    var observer = new IntersectionObserver(handleIntersection, observerOptions);

    // Observar todos los elementos con la clase stagger-reveal
    var elements = document.querySelectorAll('.stagger-reveal');
    elements.forEach(function(el) {
      observer.observe(el);
    });

    // Retornar el observer por si se necesita limpiar despues
    return observer;
  }

  // Inicializar cuando el DOM este listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStaggerReveal);
  } else {
    // DOM ya esta listo
    initStaggerReveal();
  }

  // Exponer funcion para reinicializar (util para contenido dinamico/AJAX)
  window.initStaggerReveal = initStaggerReveal;

})();
